import { Route, Routes } from "react-router-dom"
import NotFound404 from "../pages/NotFound404"
import RequireAuth from "../components/Authentication/RequireAuth";
import PersistLogin from "../components/Authentication/PersistLogin";
import ApproverViewRequest from "../pages/ApproverViewRequest";

const LimitedOpexRouter = () => {
    return (
        <Routes>      
            <Route element={<PersistLogin />}>
                <Route element={<RequireAuth allowedRoles={["200"]} />}>         
                    <Route path="*" element={<NotFound404 />} />
                </Route>     
            </Route>
        </Routes>
    )
}

export default LimitedOpexRouter;